import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Col, Button } from "reactstrap";
import {
  Schedule,
  SchedulePrint,
  GET_WEEK_START_END,
  validateTokenStorage,
} from "./../../Constants/Util";
import StoreContext from "./../../../Store/Context";
import {
  getAgendaStudent,
  getSetup,
  getFileNames,
  validateLogin,
  putFileAgendaStudent,
  putRevisado,
  deleteFile
} from "./../../Constants/Services";
import { PdfUploadModal } from "./../../Constants/Modal";
import {
  IAgenda,
  ISetup,
  INota,
  IWeekStartEnd,
  IFilesAgenda
} from "./../../Constants/Interfaces";
import moment from "moment";
import { printComponent } from "react-print-tool";

interface IAgendaState {
  dataAgenda: IAgenda[];
  dataNota: INota[];
  dataFormSetup: ISetup;
  loading: boolean;
  isOpenModalPdfUpload: boolean;
  trimestre: string;
  di_selected: string;
  not_selected: string;
  dataWeekStartEnd: IWeekStartEnd[];
  dataFSchedule: {
    date_week_selected: string;
  };
  filesObj:IFilesAgenda[];
}

class Agenda extends Component<RouteComponentProps<{}>, IAgendaState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataAgenda: [],
      dataNota: [],
      dataWeekStartEnd: [],
      dataFSchedule: {
        date_week_selected: "0",
      },
      loading: false,
      isOpenModalPdfUpload: false,
      trimestre: "I",
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      filesObj:[],
      di_selected: "",
      not_selected: "",
    };
    this.fetchValidateLogin = this.fetchValidateLogin.bind(this);
    this.fetchAgenda = this.fetchAgenda.bind(this);
    this.handleModalPDf = this.handleModalPDf.bind(this);
    this.setWeekStartEnd = this.setWeekStartEnd.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.modalSetPdf = this.modalSetPdf.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.setDataWeekStartEnd = this.setDataWeekStartEnd.bind(this);
    this.setNameFile = this.setNameFile.bind(this);
    this.setRevisado = this.setRevisado.bind(this);
    this.onClickPrint = this.onClickPrint.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.fecthFileNames = this.fecthFileNames.bind(this);
  }

  setWeekStartEnd() {
    const props = this.state;
    var dataStartTrimestre;
    var dataEndTrimestre;

    if (props.dataFormSetup.set_trimestre === "I") {
      dataStartTrimestre = props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    } else if (props.dataFormSetup.set_trimestre === "II") {
      dataStartTrimestre = props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    } else if (props.dataFormSetup.set_trimestre === "III") {
      dataStartTrimestre = props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }

    var daysMonth = GET_WEEK_START_END({
      startDate: dataStartTrimestre,
      endDate: dataEndTrimestre,
    });

    var position = 0;
    daysMonth.map((data, i) => {
      if (
        moment(new Date()).isAfter(
          moment(data.dateStart).format("YYYY-MM-DD")
        ) &&
        moment(new Date()).isBefore(
          moment(data.dateEnd).add(1, "days").format("YYYY-MM-DD")
        )
      ) {
        position = i;
      }
      return null;
    });

    this.setState({
      dataWeekStartEnd: daysMonth,
      dataFSchedule: {
        ...this.state.dataFSchedule,
        date_week_selected: position.toString(),
      },
    });
    this.fetchAgenda({
      date_week_start: daysMonth[position.toString()].dateStart,
      date_week_end: daysMonth[position.toString()].dateEnd,
    });
  }

  setDataWeekStartEnd({ date_week_selected }) {
    const props = this.state;
    if (
      Number(date_week_selected) >= 0 &&
      Number(date_week_selected) < Number(props.dataWeekStartEnd.length) &&
      moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment(props.dataWeekStartEnd[date_week_selected.toString()].dateStart).format("YYYY-MM-DD HH:mm:ss"))
    ) {
      this.setState({
        dataFSchedule: {
          date_week_selected,
        },
      });
      this.fetchAgenda({
        date_week_start: props.dataWeekStartEnd[date_week_selected].dateStart,
        date_week_end: props.dataWeekStartEnd[date_week_selected].dateEnd,
      });
    }
    else{
      var position = date_week_selected -1;
      if (
        Number(date_week_selected) >= 0 &&
        Number(date_week_selected) < Number(props.dataWeekStartEnd.length) &&
        moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment(props.dataWeekStartEnd[position.toString()].dateEnd)
        .subtract(2, "days").add(14, "hours").format("YYYY-MM-DD HH:mm:ss"))
      ){
      this.setState({
        dataFSchedule: {
          date_week_selected,
        },
      });
     
      this.fetchAgenda({
        date_week_start: props.dataWeekStartEnd[date_week_selected].dateStart,
        date_week_end:  props.dataWeekStartEnd[date_week_selected].dateEnd,
      });
      }
    }
  }

  async fetchValidateLogin() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      const response = await validateLogin(
        this.context.per_id,
        this.context.usr_type.replace(/\//g, "")
      );
      if (response.inactivo) {
        this.context.quitToken();
      }
    } else {
      const response = await validateLogin(
        this.context.per_id,
        this.context.usr_type.replace(/\//g, "")
      );
      if (response.inactivo) {
        this.context.quitToken();
      }
    }
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
      trimestre: response.set_trimestre,
      loading: false,
    });

    setTimeout(() => {
      this.setWeekStartEnd();
    }, 1000);
  }
  
  async fecthFileNames({per_id, di_id}) {
    var response;
    if (this.context.usr_type.replace(/\//g, "") === "student") {
      response = await getFileNames({
        per_id,
        di_id
      }
      );
    }
    this.setState({
      filesObj: response,
      loading: false,
    });
  }

  async fetchAgenda({ date_week_start, date_week_end }) {
    var response;
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      response = await getAgendaStudent({
        per_id: this.context.per_std,
        date_week_start,
        date_week_end,
      });
    } else {
      response = await getAgendaStudent({
        per_id: this.context.per_id,
        date_week_start,
        date_week_end,
      });
    }

    this.setState({
      dataAgenda: response.agenda,
      dataNota: response.nota,
      loading: false,
    });
  }

  componentDidMount() {
    this.fetchValidateLogin();
    this.fetchSetup();
  }

  deleteFile({ di_id,per_id }) {
    if (this.context.usr_type.replace(/\//g, "") === "student") {
      const body = {
        di_id,
        per_id
      };
      deleteFile(body)
      this.rechargeData()
    }
  }

  modalSetPdf({ di_id, not_id }) {
    if (this.context.usr_type.replace(/\//g, "") === "student") {
      this.setState({
        isOpenModalPdfUpload: true,
        di_selected: di_id,
        not_selected: not_id,
      });
    }
  }

  handleModalPDf() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    const props = this.state;
    this.setState((prevState) => ({
      isOpenModalPdfUpload: !prevState.isOpenModalPdfUpload,
    }));

    setTimeout(() => {
      this.fetchAgenda({
        date_week_start:
          props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
            .dateStart,
        date_week_end: props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
        .dateEnd,
      });
    }, 500);
  }

  rechargeData() {
    const props = this.state;
    this.setState({ loading: true });
    if (
      props.dataWeekStartEnd[props.dataFSchedule.date_week_selected] !==
        undefined &&
      props.dataWeekStartEnd[props.dataFSchedule.date_week_selected] !==
        undefined
    ) {
      setTimeout(() => {
        this.fetchAgenda({
          date_week_start:
            props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
              .dateStart,
          date_week_end: props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
          .dateEnd,
        });
      }, 1000);
    }
  }

  setNameFile({ name_file, di_id, per_id,count,up_code}) {
    const body = {
      di_id,
      per_id,
      name_file,
      count,
      up_code
    };
    putFileAgendaStudent(body);
  }

  setRevisado({ di_id, not_person }) {
    const props = this.state;
    const body = {
      di_id,
      per_id: not_person,
    };
    putRevisado(body);
    setTimeout(() => {
      this.fetchAgenda({
        date_week_start:
          props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
            .dateStart,
        date_week_end: props.dataWeekStartEnd[props.dataFSchedule.date_week_selected]
        .dateEnd,
      });
    }, 1000);
  }

  onClickPrint = () => {
    const props = this.state;
    printComponent(
      <SchedulePrint
        data={props.dataAgenda}
        dataNota={props.dataNota}
        modalSetPdf={this.modalSetPdf}
        per_id={this.context.per_id}
        props={props.trimestre}
        rechargeData={this.rechargeData}
        loading={props.loading}
        dataWeekStartEnd={props.dataWeekStartEnd}
        setDataWeekStartEnd={this.setDataWeekStartEnd}
        dataFSchedule={props.dataFSchedule}
        setRevisado={this.setRevisado}
      />
    );
  };

  render() {
    const props = this.state;
    var per_id;
    var per_type;
    if(this.context.usr_type.replace(/\//g, "") === "student"){
    per_id = this.context.per_id;
    per_type ="student";
    }
    else{
      per_id = this.context.per_std;
      per_type ="parents";
    }
    const bodyPdf = {
      di_id: props.di_selected,
      per_id: this.context.per_id,
    };
    return (
      <React.Fragment>
        {props.isOpenModalPdfUpload && (
          <PdfUploadModal
            title="Guardar tarea"
            isOpen={props.isOpenModalPdfUpload}
            toggle={this.handleModalPDf}
            namePdf={bodyPdf}
            setNameFile={this.setNameFile}
          />
        )}
        <Col xs={12} className="text-right">
          <Button className="info" onClick={() => this.onClickPrint()}>
            Imprimir
          </Button>
        </Col>
        <Schedule
          data={props.dataAgenda}
          dataNota={props.dataNota}
          modalSetPdf={this.modalSetPdf}
          per_id={per_id}
          props={props.trimestre}
          rechargeData={this.rechargeData}
          loading={props.loading}
          dataWeekStartEnd={props.dataWeekStartEnd}
          setDataWeekStartEnd={this.setDataWeekStartEnd}
          dataFSchedule={props.dataFSchedule}
          setRevisado={this.setRevisado}
          per_type = {per_type}
          deleteFile= {this.deleteFile}
          filesObj ={props.filesObj}
          getFilesNames ={this.fecthFileNames}
        />
      </React.Fragment>
    );
  }
}
export default Agenda;
